/**
 * Header dropdowns Vue Mixin
 * ------------------------------------------------------------------------------
 * Menus and dropdown toggles and functionality
 *
 * Mixin is shared with:
 * - app.js
 */

import Vue from 'vue'

import { insertAfter } from '../utils/helpers'

export const headerDropdowns = {
  directives: {
    initMegamenu: {
      inserted (el, binding, vnode) {
        const dropdown = document.querySelector('[parent-item="' + binding.value + '"]')
        const ctaLink = document.querySelector('[cta-parent-item="' + binding.value + '"]')

        if (!binding.value.includes('__')) { // If top level menu item
          el.addEventListener('mouseover', () => {
            if (window.matchMedia('(min-width: 1024px)').matches) {
              vnode.context.closeAllMegamenus()
            }
          })
        }

        if (dropdown) {
          Vue.set(vnode.context.megamenuToggles, binding.value, false)

          insertAfter(dropdown, el)

          if (!binding.value.includes('__')) {
            el.addEventListener('mouseover', () => {
              if (window.matchMedia('(min-width: 1024px)').matches) {
                vnode.context.toggleMegamenu(binding.value)
              }
            })
          }

          el.addEventListener('click', (e) => {
            if (window.matchMedia('(max-width: 1023px)').matches) {
              vnode.context.toggleMegamenu(binding.value)
            }
          })
        }
        // Desktop positioning won't work for mobile
        // Inserting another CTA link to follow mobile design
        if (ctaLink) insertAfter(ctaLink, el)
      }
    }
  },

  data: {
    isMenuOpen: false,
    megamenuToggles: {},
    isSearchOpen: false,
    isMinicartOpen: false
  },

  watch: {
    isMenuOpen (value) {
      if (value) {
        document.querySelector('body').classList.add('no-scroll')
      } else {
        document.querySelector('body').classList.remove('no-scroll')
      }
    }
  },

  methods: {
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
      this.isSearchOpen = false
      this.isMinicartOpen = false
      this.closeAllMegamenus()
    },

    toggleMegamenu (parent) {
      if (!parent.includes('__')) { // If top level menu item
        for (const menu in this.megamenuToggles) {
          if (menu !== parent) { this.megamenuToggles[menu] = false }
        }
      }

      this.megamenuToggles[parent] = !this.megamenuToggles[parent]
    },

    closeAllMegamenus () {
      for (const menu in this.megamenuToggles) {
        this.megamenuToggles[menu] = false
      }
    },

    toggleSearch () {
      this.isSearchOpen = !this.isSearchOpen
      this.isMinicartOpen = false
      this.isMenuOpen = false
      this.closeAllMegamenus()

      if (this.isSearchOpen && this.$refs.search) {
        this.$nextTick(() => {
          this.$refs.search.select()
        })
      }
    },

    toggleMinicart () {
      this.isMinicartOpen = !this.isMinicartOpen
      this.isSearchOpen = false
      this.isMenuOpen = false
      this.closeAllMegamenus()
    }
  }
}
